import { Option } from '../engine/models/models';
export class GroupedOptionsModel {
  groups: TagGroup[];
  options: Option[];
}
export class TagGroup {
  tagName: string;
  tagDisplayName: string;
  displayOrder: number;
}
export class ExportPinOptionsModel {
  title: string | undefined;
  displayOrder: number;
  options: { description: string, url: string, optionId: number }[];
}
